import type { FormTag } from '@/utils/grammar'

interface GrammarTagsProps {
  tags: FormTag[]
  size?: 'sm' | 'md'
}

export function GrammarTags({ tags, size = 'sm' }: GrammarTagsProps) {
  if (tags.length === 0) return null

  const sizeClasses = size === 'md'
    ? 'text-xs px-2.5 py-1'
    : 'text-[11px] px-2 py-0.5'

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {tags.map((tag) => (
        <span
          key={tag.label}
          className={`inline-flex items-center gap-1 font-light rounded-full bg-surface-bg border border-border-surface text-muted ${sizeClasses}`}
        >
          {tag.label}
          {tag.hint && (
            <span className="text-accent/70">{tag.hint}</span>
          )}
        </span>
      ))}
    </div>
  )
}
